<div class="payment-preference-form-container">
  <form #PreferenceForm="ngForm">
    <div class="field-row">
      <rms-input name="ACHAuthorizationRecipientEmail" label="ACH Authorization Recipient" [(ngModel)]="Preference.ACHAuthorizationRecipientEmail"></rms-input>
    </div>
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!PreferenceForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
